"use client";

import { useState } from "react";
import { EventView } from "./characterViews";

/**
 * キャラ情報のイベントのタブ。キャラの持つイベントを、キャラに見えていることだけで見る。
 * 一覧は 進行中・完了 のタブに分け、1 件を押すと見えていることと経過を出す。真相は画面に出さない。
 * 中身はキャラの中身（GET /api/character/detail）の events
 */
export default function PlayEvents({ events }: { events: EventView[] }) {
  const [opened, setOpened] = useState<string | null>(null);
  const [sub, setSub] = useState<"open" | "ended">("open");
  const event = events.find((one) => one.id === opened) ?? null;

  if (event) {
    return (
      <div>
        <div className="pl-title">
          <h2>{event.name}</h2>
          <span>{event.state_label}</span>
          <button type="button" className="pl-back" onClick={() => setOpened(null)}>
            戻る
          </button>
        </div>
        <div className="pl-card">
          <p className="pl-card-line">{event.started} に起きた</p>
          <p className="review-p" style={{ marginTop: 10, whiteSpace: "pre-wrap" }}>
            {event.seen || "まだ何も分かっていません。"}
          </p>
        </div>
        {event.history.length > 0 ? (
          <ul className="pl-log-rows pl-card">
            {event.history.map((one, index) => (
              <li key={index}>
                <span className="pl-log-time">{one.from ?? ""}</span>
                <span>{one.text}</span>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    );
  }

  const shown = events.filter((one) => (sub === "ended" ? one.ended : !one.ended));
  return (
    <div>
      <div className="pl-subtabs" role="tablist">
        {([["open", "進行中"], ["ended", "完了"]] as const).map(([key, label]) => (
          <button key={key} type="button" role="tab" aria-selected={sub === key} className={sub === key ? "pl-subtab pl-subtab-on" : "pl-subtab"} onClick={() => setSub(key)}>
            {label}
          </button>
        ))}
      </div>
      {shown.length === 0 ? (
        <div className="pl-empty">{sub === "ended" ? "完了したイベントはありません。" : "進行中のイベントはありません。"}</div>
      ) : (
        <div className="pl-list">
          {shown.map((one) => (
            <button key={one.id} type="button" className="pl-card pl-card-btn" onClick={() => setOpened(one.id)}>
              <p className="pl-card-name">
                {one.name}
                <span className="pl-card-tag">{one.state_label}</span>
              </p>
              <p className="pl-card-line">{one.started} に起きた</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
